import request from '@/utils/request'


// 查询奖品设置列表
export function listLotteryPrize(query) {
  return request({
    url: '/biz/admin/lottery/lottery/prize/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询奖品设置分页
export function pageLotteryPrize(query) {
  return request({
    url: '/biz/admin/lottery/lottery/prize/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询奖品设置详细
export function getLotteryPrize(data) {
  return request({
    url: '/biz/admin/lottery/lottery/prize/detail',
    method: 'get',
    params: data
  })
}

// 新增奖品设置
export function addLotteryPrize(data) {
  return request({
    url: '/biz/admin/lottery/lottery/prize/add',
    method: 'post',
    data: data
  })
}

// 修改奖品设置
export function updateLotteryPrize(data) {
  return request({
    url: '/biz/admin/lottery/lottery/prize/edit',
    method: 'post',
    data: data
  })
}

// 删除奖品设置
export function delLotteryPrize(data) {
  return request({
    url: '/biz/admin/lottery/lottery/prize/delete',
    method: 'post',
    data: data
  })
}
